/**
 * WordPress dependencies
 */
import { SVG, Circle } from '@wordpress/primitives';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageControlIcon = () => /*#__PURE__*/_jsx(SVG, {
  width: "8",
  height: "8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx(Circle, {
    cx: "4",
    cy: "4",
    r: "4"
  })
});